module.exports = __webpack_public_path__ + "assets/img/brand-05.cc494e3f.png";